import React from "react";
import "./DonateViaUpi.css";
// Import QR code images
import qrcode1 from "../assets/qrcode1.png";
import qrcode2 from "../assets/qrcode2.png";

const DonateViaUpi = () => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("Copied to clipboard!");
    });
  };

  return (
    <div className="donate-upi-container">
      <div className="upi-boxes-wrapper">
        
        {/* Box 1: Bank Transfer */}
        <div className="upi-box bank-transfer-box">
          <div className="box-header">
            <h3 className="box-title">Donation Through Bank (NEFT/RTGS)</h3>
          </div>
          <div className="box-content">
            <div className="bank-details">
              <div className="detail-row">
                <div className="detail-left">
                  <span className="detail-label">Bank Name:</span>
                  <span className="detail-value">HDFC Bank</span>
                </div>
                <button 
                  className="copy-btn"
                  onClick={() => copyToClipboard("HDFC Bank")}
                >
                  Copy
                </button>
              </div>
              
              <div className="detail-row">
                <div className="detail-left">
                  <span className="detail-label">Account Name:</span>
                  <span className="detail-value">ISKCON</span>
                </div>
                <button 
                  className="copy-btn"
                  onClick={() => copyToClipboard("ISKCON")}
                >
                  Copy
                </button>
              </div>
              
              <div className="detail-row">
                <div className="detail-left">
                  <span className="detail-label">Account Number:</span>
                  <span className="detail-value">50100436709020</span>
                </div>
                <button 
                  className="copy-btn"
                  onClick={() => copyToClipboard("50100436709020")}
                >
                  Copy
                </button>
              </div>
              
              <div className="detail-row">
                <div className="detail-left">
                  <span className="detail-label">IFSC Code:</span>
                  <span className="detail-value">HDFC0000568</span>
                </div>
                <button 
                  className="copy-btn"
                  onClick={() => copyToClipboard("HDFC0000568")}
                >
                  Copy
                </button>
              </div>
              
              <div className="detail-row">
                <div className="detail-left">
                  <span className="detail-label">Branch:</span>
                  <span className="detail-value">ONE TOWN VIJAYAWADA</span>
                </div>
                <button 
                  className="copy-btn"
                  onClick={() => copyToClipboard("ONE TOWN VIJAYAWADA")}
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Box 2: QR Code 1 - This one gets the margin top */}
        <div className="upi-box qr-code-box">
          <div className="box-header">
            <h3 className="box-title">Donate using QR Code</h3>
          </div>
          <div className="box-content-with-margin"> {/* Changed to box-content-with-margin */}
            <div className="qr-placeholder">
              <div className="qr-code">
                <img src={qrcode1} alt="QR Code for Donation" className="qr-image" />
              </div>
              <div className="qr-text">
                <p className="qr-name">ISKCON Vijayawada</p>
                <button className="donate-btn">Donate now</button>
              </div>
            </div>
          </div>
        </div>

        {/* Box 3: QR Code 2 */}
        <div className="upi-box qr-code-box">
          <div className="box-header">
            <h3 className="box-title">Donate Through UPI</h3>
          </div>
          
          <div className="upi-note">
            Scan the QR code to donate instantly
          </div>
          
          <div className="box-content"> {/* This one stays without margin */}
            <div className="qr-placeholder">
              <div className="qr-code">
                <img src={qrcode2} alt="UPI QR Code" className="qr-image" />
              </div>
              <div className="upi-or">
                <span>OR</span>
              </div>
              <div className="qr-text">
                <div className="upi-section">
                  <span className="upi-label">UPI ID:</span>
                  <div className="upi-id-wrapper">
                    <span className="upi-id">iskconvijayawada@idfcbank</span>
                    <button 
                      className="copy-btn upi-copy-btn"
                      onClick={() => copyToClipboard("ISCKONVIJAYAWADA@IDFCBANK")}
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default DonateViaUpi;